export default function FocusOnFirstError(errors) {
    const keyify = (obj, prefix = '') =>
        Object.keys(obj).reduce((res, el) => {
            if (Array.isArray(obj[el])) {
                return keyify(obj[el], prefix + el + '.');
            } else if (typeof obj[el] === 'object' && obj[el] !== null) {
                return [...res, ...keyify(obj[el], prefix + el + '.')];
            } else {
                return [...res, prefix + el];
            }
        }, []);

    const keys = keyify(errors);

    if (keys.length > 0) {
        const selector = `[name="${keys[0]}"]`;
        const errorElement = document.querySelector(selector);
        if (errorElement) {
            setTimeout(() => {
                errorElement.focus();
            }, 100);
        }
    }
}
